import React from 'react';
import {useTranslation} from 'react-i18next';
import globalStore from '@services/global.state';
import {ReactComponent as EmailIcon} from '@/assets/icons/me/email.svg';
import {copyText} from '@/utils';
import {currentBrand} from '@/brands';

const Contact = () => {
  const {i18n} = useTranslation();
  const mailAddress = currentBrand.supportEmail || '';

  if (!mailAddress) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-2 border-t border-t-line py-3 text-xs font-medium">
      <p>{i18n.t('me.tip.anyquery')}</p>
      <p
        className="flex flex-row items-center gap-2 text-sm text-c1"
        onClick={() => {
          copyText(mailAddress);
          globalStore.globalTotal.next({
            type: 'success',
            message: i18n.t('tip.copysuccess'),
          });
        }}>
        <EmailIcon className="size-4 text-c1" />
        <span>{mailAddress}</span>
      </p>
    </div>
  );
};

export default Contact;
